module.exports = __webpack_public_path__ + "img/morleyp.49ad7cac.svg";